/* eslint-disable no-empty, no-redeclare, no-unused-vars */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { laydate } from './laydate.js';
import { laypage } from './laypage.js';
import { layer } from './layer.js';

var $ = jquery;
var escapeHtml = function(value){
	return String(value == null ? '' : value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
};

var getDialogMetrics = function () {
	var viewportWidth =
		window.innerWidth || document.documentElement.clientWidth || 1280;
	var viewportHeight =
		window.innerHeight || document.documentElement.clientHeight || 800;
	var compact = viewportWidth <= 768;
	var gutter = compact ? 16 : 48;
	var width = Math.min(1120, viewportWidth - gutter);
	var height = Math.min(820, viewportHeight - gutter);

	width = Math.max(width, Math.min(compact ? 300 : 760, viewportWidth - 8));
	height = Math.max(height, Math.min(compact ? 420 : 620, viewportHeight - 8));

	var headerHeight = compact ? 152 : 88;
	var footerHeight = compact ? 126 : 74;
	var contentHeight = Math.max(height - headerHeight - footerHeight, compact ? 220 : 320);

	return {
		area: [Math.round(width) + 'px', Math.round(height) + 'px'],
		dialogHeight: Math.round(height - 32) + 'px',
		contentHeight: Math.round(contentHeight) + 'px'
	};
};

	i18n.set({
		messages: {
			'zh-CN': {
				objectManage: {
					object: '对象',
					name: '名称',
					pleaseSelect: '请选择',
					dateRange: '日期范围',
					search: '搜索',
					selectAllPage: '本页全选',
					selectedLabel: '已选',
					selectedUnit: '个',
					price: '价格',
					time: '时间',
					maxSelect: '最多只能选{max}个',
					selectObject: '选择{object}',
					confirm: '确定',
					cancel: '取消'
				}
			},
			'en-US': {
				objectManage: {
					object: 'Object',
					name: 'Name',
					pleaseSelect: 'Please select',
					dateRange: 'Date Range',
					search: 'Search',
					selectAllPage: 'Select all on page',
					selectedLabel: 'Selected',
					selectedUnit: 'items',
					price: 'Price',
					time: 'Time',
					maxSelect: 'You can select at most {max}',
					selectObject: 'Select {object}',
					confirm: 'Confirm',
					cancel: 'Cancel'
				}
			}
		}
	});
	var t = function(key, fallback, params){
		return i18n.translate('objectManage.' + key, params, { default: fallback });
	};
	
	function ObjectManage(){
		
	}
	var objectManage = ObjectManage;
	
	objectManage.prototype.options={};
	objectManage.prototype.init=function(options){
		this.options=options;
		this._state = this._state || {
			data: {},
			dataMultiple: []
		};
	}
	objectManage.prototype.changeUrl=function(title,url){
		$("#"+this.options.elem+"_object_manage_div").remove();
		this.options.objectUrl=url;
		this.options.objectTitle=title;
	}
	objectManage.prototype.render=function(){
		var state = this._state || (this._state = {
			data: {},
			dataMultiple: []
		});
		var object_data = state.data || {};
		var object_data_multiple = Array.isArray(state.dataMultiple) ? state.dataMultiple : [];
		var syncState = function(){
			state.data = object_data;
			state.dataMultiple = object_data_multiple;
		};
		syncState();
		var load=layer.load();
		var multiple=this.options.multiple;
		var objectUrl=this.options.objectUrl;
		var cateUrl=this.options.cateUrl;
		var cateName=this.options.cateName||'';
		var cateID=this.options.elem+"_"+this.options.cateName;
		var cateTitle=this.options.cateTitle;
		
		var cate1Url=this.options.cate1Url;
		var cate1Name=this.options.cate1Name;
		var cate1ID=this.options.elem+"_"+this.options.cate1Name;
		var cate1Title=this.options.cate1Title;
		var object_time='';
		var object_total=0;
		var callback=this.options.callback;
		var objectMax=this.options.objectMax||12;
		var objectTitle=this.options.objectTitle||t('object', '对象');
		var id;

		var title=this.options.title||t('name', '名称');
		if(this.options.date==undefined){
			var date=false;
		}else{
			var date=this.options.date;
		}
		var name=this.options.name||'';
		var elem=this.options.elem;
		
		var object_manage_div= this.options.elem+"_object_manage_div";
		var object_manage= this.options.elem+"_object_manage";
		var object_search_input=this.options.elem+"_object_search_input";
		var object_search_date=this.options.elem+"_object_search_date";
		var object_search_btn=this.options.elem+"_object_search_btn";
		var object_content=this.options.elem+"_object_content";
		var object_page=this.options.elem+"_object_page";
		var object_item=this.options.elem+"_object_item";
		var object_select_all=this.options.elem+"_object_select_all";
		var object_select_all_num=this.options.elem+"_object_select_all_num";
		var pagesize="15";
		var normalizeObjectItem = function(item){
			item = item || {};
			return {
				id: item.id,
				icon: item.icon == null ? '' : String(item.icon),
				time: item.time == null ? '' : String(item.time),
				price: item.price == null ? '' : String(item.price),
				money_type: item.money_type == null ? '' : String(item.money_type),
				title: item.title == null ? '' : String(item.title),
				specs_title: item.specs_title == null ? '-1' : String(item.specs_title)
			};
		};
		var buildObjectItemHtml = function(rawItem){
			var item = normalizeObjectItem(rawItem);
			var inner_html = '';
			if(item.icon !== ''){
				inner_html += "<img src='" + escapeHtml(item.icon) + "'/>";
			}
			inner_html += "<p class='title'>" + escapeHtml(item.title) + "</p>";
			if(item.specs_title !== '-1'){
				inner_html += "<p class='specs'>" + escapeHtml(item.specs_title) + "</p>";
			}
			if(item.price !== ''){
				inner_html += "<p class='price'>" + t('price', '价格') + ":" + escapeHtml(item.price) + escapeHtml(item.money_type) + "</p>";
			}
			if(item.time !== ''){
				inner_html += "<p class='time'>" + t('time', '时间') + ":" + escapeHtml(item.time) + "</p>";
			}
			return "<a data-id='" + item.id + "' data-icon='" + escapeHtml(item.icon) + "' data-time='" + escapeHtml(item.time) + "' data-price='" + escapeHtml(item.price) + "' data-money_type='" + escapeHtml(item.money_type) + "' data-title='" + escapeHtml(item.title) + "' id='" + object_item + '_' + item.id + "'>" + inner_html + "<ins><i class='layui-icon layui-icon-ok'></i></ins></a>";
		};
		var syncObjectSelectAll = function(){
			var isall = true;
			$("#"+object_content+" a").each(function(){
				if(!$(this).hasClass('object-item-select')){
					isall = false;
				}
			});
			$("#"+object_select_all).prop('checked', isall);
		};
		var bindObjectItems = function(){
			$("#"+object_content+" a").off('click').on('click', function(){
				if($(this).hasClass('object-item-select')){
					$(this).removeClass('object-item-select');
					let tmp_id=$(this).attr('data-id');
					if(multiple==false){
						object_data={};
						syncState();
					}else{
						for(let i in object_data_multiple){
							if(object_data_multiple[i]['id']==tmp_id){
								object_data_multiple.splice(i,1);
							}
						}
						$("#"+object_select_all_num).text(object_data_multiple.length);
					}
				}else{
					if(multiple==false){
						$("#"+object_content+" a").removeClass('object-item-select');
						object_data={id:$(this).attr('data-id'),money_type:$(this).attr('data-money_type'),price:$(this).attr('data-price'),icon:$(this).attr('data-icon'),time:$(this).attr('data-time'),title:$(this).attr('data-title')};
						syncState();
						$(this).addClass('object-item-select');
					}else{
						if(object_data_multiple.length>=objectMax){
							layer.msg(t('maxSelect', '最多只能选{max}个', {max: objectMax}));
							return false;
						}else{
							var tmp_object_data={id:$(this).attr('data-id'),money_type:$(this).attr('data-money_type'),price:$(this).attr('data-price'),icon:$(this).attr('data-icon'),time:$(this).attr('data-time'),title:$(this).attr('data-title')};
							object_data_multiple.push(tmp_object_data);
							$("#"+object_select_all_num).text(object_data_multiple.length);
							$(this).addClass('object-item-select');
						}
					}
				}
				syncObjectSelectAll();
			});
		};
		var renderObjectList = function(list){
			list = list || [];
			$("#"+object_content).empty();
			for(var i=0;i<list.length;i++){
				$("#"+object_content).append(buildObjectItemHtml(list[i]));
			}
			for(let j in object_data_multiple){
				$("#"+object_item+"_"+object_data_multiple[j].id).addClass('object-item-select');
			}
			bindObjectItems();
			syncObjectSelectAll();
		};
		var applyRemoteConfig = function(result){
			result = result || {};
			cateUrl = result.cateUrl;
			cateName = result.cateName;
			cateID = elem+"_"+result.cateName;
			cateTitle = result.cateTitle;
			cate1Url = result.cate1Url;
			cate1Name = result.cate1Name;
			cate1ID = elem+"_"+result.cate1Name;
			cate1Title = result.cate1Title;
			title = result.title;
			name = result.name;
			id = elem+"_"+name;
		};
		var collectSearchData = function(page){
			var data={page:page || 1,pagesize:pagesize};
			if($("#"+object_search_date).val()!=''){
				data.object_time = object_time;
			}
			if(cateTitle!=undefined&&cateTitle!=''&&cateTitle!=null){
				if($("#"+cateID).val()!=''){
					data[cateName]=$("#"+cateID).val();
				}
			}
			if(cate1Title!=undefined&&cate1Title!=''&&cate1Title!=null){
				if($("#"+cate1ID).val()!=''){
					data[cate1Name]=$("#"+cate1ID).val();
				}
			}
			if($("#"+object_search_input).val()!=''){
				data[name]=$("#"+object_search_input).val();
			}
			return data;
		};
		var loadCategoryOptions = function(url, selectId){
			if(!url || !selectId){
				return $.Deferred().resolve().promise();
			}
			return $.ajax({
				type:'get',
				dataType:'json',
				url:url
			}).done(function(result){
				result = result && result.data;
				$("#"+selectId).empty();
				$("#"+selectId).append("<option value=''>"+t('pleaseSelect', '请选择')+"</option>");
				if(typeof(result)=='object'&&result.length){
					for(var i=0;i<result.length;i++){
						$("#"+selectId).append("<option value='"+result[i].id+"'>"+escapeHtml(result[i].title)+"</option>");
					}
				}
			});
		};
		var fetchObjectList = function(page, callbackFn){
			$.ajax({
				type:'post',
				dataType:'json',
				url:objectUrl,
				data:collectSearchData(page),
				success:function(result){
					callbackFn && callbackFn(result || {});
				}
			});
		};
		var bindPager = function(){
			laypage.render({
				elem: object_page
				,count: object_total
				,limit:pagesize
				,jump: function(obj, first){
					if(first){
						return;
					}
					fetchObjectList(obj.curr, function(result){
						renderObjectList(result.data);
					});
				}
			});
		};
		var openDialog = function(){
			var metrics = getDialogMetrics();
			$("#"+object_manage).css({
				'--object-dialog-height': metrics.dialogHeight,
				'--object-content-height': metrics.contentHeight
			});
			
			this.options.layer=layer.open({
				  type: 1,
				  title: t('selectObject', '选择{object}', {object: objectTitle}),
				  closeBtn: 1,
				  shadeClose: false,
				  skin: 'layui-layer-g3ys-form-big object-manage-layer',
				  resize:false,
				  scrollbar:false,
				  btn: [t('confirm', '确定'), t('cancel', '取消')],
				  area: metrics.area,
				  content: $('#'+object_manage),
				  success: function(layero, index){
						$("#"+object_manage_div).show();
						layer.close(load);
				  },
				  end:function(){
						$("#"+object_manage_div).hide();
				  },
				  yes:function(index,layero){
					  layer.close(index);
					if(multiple){
						if(object_data_multiple.length>0){
							for(let i in object_data_multiple){
								let item=object_data_multiple[i];
								var arr = Object.keys(item);
								(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',item['id'],item);
							}
							object_data_multiple=Array();
							syncState();
							$("#"+object_select_all).prop('checked',false);
							$("#"+object_content+" a").removeClass("object-item-select");
							$("#"+object_select_all_num).text('0');
						}
					}else{
						var arr = Object.keys(object_data); 
						(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',object_data['id'],object_data);
						object_data={};
						syncState();
						$("#"+object_content+" a").removeClass("object-item-select");
					}
					$("#"+object_manage_div).hide();
				  }
			});
		}.bind(this);
		var ensureShell = function(){
			if($("#"+object_manage_div).length>0){
				return;
			}
			var html="";
			html=html+'<div id="'+object_manage_div+'" class="object-manage">';
			html=html+'<div id="'+object_manage+'" class="object-manage-shell">';
			html=html+'<div class="object-manage-header">';
			html=html+'<div class="object-manage-header-left">'
			if(cateTitle!=undefined&&cateTitle!=''&&cateTitle!=null){
				html=html+'<label>'+escapeHtml(cateTitle)+'</label>';
				html=html+'<select id="'+cateID+'"><option value="">'+t('pleaseSelect', '请选择')+'</option></select>';
			}
			if(cate1Title!=undefined&&cate1Title!=''&&cate1Title!=null){
				html=html+'<label>'+escapeHtml(cate1Title)+'</label>';
				html=html+'<select  id="'+cate1ID+'"><option value="">'+t('pleaseSelect', '请选择')+'</option></select>';
			}
			if(date){
				html=html+'<label>'+t('dateRange', '日期范围')+'</label>';
				html=html+'<input type="text" class="layui-input layui-input-sm" id="'+object_search_date+'" >';
			}else{
				html=html+'<input type="text" class="layui-input layui-input-sm layui-hide" id="'+object_search_date+'" >';
			}
			html=html+'<label>'+escapeHtml(title)+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+object_search_input+'" >';
			html=html+'<button class="layui-btn layui-btn-sm" id="'+object_search_btn+'"><i class="layui-icon">&#xe615;</i>'+t('search', '搜索')+'</button>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'<div class="object-content" id="'+object_content+'">';
			html=html+'</div>';
			html=html+'<div class="object_page">';
			if(multiple){
			html=html+'<div class="object_page_left">';
			html=html+'<label class="object-page-check"><input type="checkbox" id="'+object_select_all+'"/><span>'+t('selectAllPage', '本页全选')+'</span></label>';
			html=html+'<label class="object-page-selected"><span class="object-page-selected-label">'+t('selectedLabel', '已选')+'</span><span class="object-page-selected-count" id="'+object_select_all_num+'">0</span><span class="object-page-selected-unit">'+t('selectedUnit', '个')+'</span></label>';
			html=html+'</div>';
			}
			html=html+'<div class="object_page_right" id="'+object_page+'"></div>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'</div>';
			$('body').append(html);
			
			if(multiple){
				$("#"+object_select_all).click(function(){
					if($(this).prop('checked')){
						$("#"+object_content+" a").each(function(){
							if($(this).hasClass('object-item-select')){
								
							}else{
								$(this).addClass('object-item-select');
								var tmp_object_data={id:$(this).attr('data-id'),icon:$(this).attr('data-icon'),money_type:$(this).attr('data-money_type'),title:$(this).attr('data-title'),price:$(this).attr('data-price')};
								object_data_multiple.push(tmp_object_data);
								$("#"+object_select_all_num).text(object_data_multiple.length);
							}
						})
					}else{
						$("#"+object_content+" a").each(function(){
							if($(this).hasClass('object-item-select')){
								$(this).removeClass('object-item-select');
								var tmp_id=$(this).attr('data-id');
								for(let i in object_data_multiple){
									if(object_data_multiple[i].id==tmp_id){
										object_data_multiple.splice(i,1);
									}
								}
								$("#"+object_select_all_num).text(object_data_multiple.length);
							}else{
								
							}
						})
					}
				});
			}
			/*时间范围选择*/
			laydate.render({
				elem: '#'+object_search_date
				,range: true
				,done: function(value, date, endDate){
					object_time=date.year+"-"+date.month+"-"+date.date+"~"+endDate.year+"-"+endDate.month+"-"+endDate.date;
				}
			});
			
			/*搜索事件*/
			$("#"+object_search_btn).click(function(){
				var load=layer.load();
				fetchObjectList(1, function(result){
					layer.close(load);
					var list = result.data;
					object_total=result.count;
					renderObjectList(list);
					bindPager();
				});
				return false;
			});
		};
		var loadInitialData = function(callbackFn){
			fetchObjectList(1, function(result){
				$("#"+object_content).empty();
				var list = result.data;
				object_total=result.count;
				renderObjectList(list);
				bindPager();
				callbackFn && callbackFn();
			});
		};
		
		if($("#"+object_manage_div).length>0){
			openDialog();
			return;
		}
		
		var bootstrap = $.Deferred().resolve().promise();
		if(cateName==''||name==''){
			bootstrap = $.ajax({
				type:'post',
				dataType:'json',
				url:objectUrl,
				data:{cate:true}
			}).done(function(result){
				applyRemoteConfig(result);
			});
		}
		
		bootstrap.always(function(){
			ensureShell();
			$.when(
				loadCategoryOptions(cateUrl, cateID),
				loadCategoryOptions(cate1Url, cate1ID)
			).always(function(){
				loadInitialData(function(){
					openDialog();
				});
			});
		});
	}
	objectManage.prototype.close=function(){
		layer.close(this.options.layer);
	}
export { ObjectManage as objectManage };
